// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__iicIl","row":"ProcedureTreatmentSummary_row__ks_dJ"};